import { styled } from 'libs/ui/styled';

export const RootStyled = styled('div')(() => ({
  overflow: 'hidden',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  position: 'absolute',
  zIndex: 1,
}));

export const CanvasStyled = styled('canvas')(({ theme }) => ({
  width: '100%',
  height: '100%',
  '--gradient-color-1': theme.palette.mode === 'light' ? '#1A5FEA' : '#00FAFF',
  '--gradient-color-2': theme.palette.mode === 'light' ? '#a1dff5' : '#005478',
  '--gradient-color-3': theme.palette.mode === 'light' ? '#B8D0FF' : '#008BC8',
  '--gradient-color-4': theme.palette.mode === 'light' ? '#00B2FF' : '#00425E',
  opacity: 0.8,
  zIndex: 0,
  pointerEvents: 'none',
}));
